<ion-header>
  <ion-toolbar>
    <ion-title>{{ 'm/task-process/more/annotations' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismissModal()" class="close-modal-button">
        <ion-icon slot="icon-only" name="close-circle-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ng-container *ngFor="let annotation of annotations">
    <div *ngIf="annotation.dayIndicatorFormat" class="bubble-day-indicator">
      <span>{{ annotation.datetime | dateTimezone: annotation.dayIndicatorFormat }}</span>
    </div>
    <app-message-in-task-process
      [message]="annotation"
      [taskProcessContext]="taskProcessContext"
      [isAnnotationOrHelpModal]="true">
    </app-message-in-task-process>
  </ng-container>
  <div *ngIf="annotations.length > 0" class="separator-bar"></div>

  <textarea
    [(ngModel)]="newAnnotationText"
    (click)="onTextareaClicked($event)"
    rows="4"
    class="alc-annotations-and-help-requests-textarea"
    placeholder="{{ 'm/task-process/annotations/placeholder' | translate }}"></textarea>
  <div class="buttons-container">
    <ion-button
      *ngIf="canPutOnHold"
      (click)="onAnnotate(true)"
      [disabled]="isSubmitting"
      fill="outline"
      class="annotate-and-put-on-hold"
      >{{ 'm/task-process/annotations/annotate-and-put-on-hold' | translate }}</ion-button
    >
    <ion-button (click)="onAnnotate(false)" [disabled]="isSubmitting">{{
      'm/task-process/annotations/annotate' | translate
    }}</ion-button>
  </div>
</ion-content>
